import MomentUtils from '@date-io/moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import React from 'react';
import { strToDate, DATE_FORMAT, todayLastYearDate } from '../../utils/DateUtils';

const CustomDatePicker = ({
  value,
  setValue,
  minDate,
  maxDate,
  label,
  disablePast,
  readOnly,
  disabled,
  style,
  disableMinDate,
  ...restProps
}) => {
  const handleBlur = e => {
    const dateValue = e.target.value;
    setValue(dateValue.isBlank() ? null : strToDate(dateValue));
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDatePicker
        style={{ width: 140, ...style }}
        disableToolbar
        disablePast={disablePast}
        disabled={disabled}
        autoOk
        variant="inline"
        format={DATE_FORMAT}
        margin="dense"
        invalidDateMessage="Fecha incorrecta"
        id={`date-picker-inline-${label}`}
        label={label || 'Fecha'}
        minDate={readOnly || minDate || disableMinDate ? minDate : todayLastYearDate()}
        maxDate={maxDate || undefined}
        value={value}
        onChange={() => undefined}
        onAccept={setValue}
        onBlur={!readOnly ? handleBlur : undefined}
        inputProps={{ readOnly: !!readOnly }}
        KeyboardButtonProps={{
          disabled: !!readOnly || !!disabled,
          'aria-label': 'change date',
        }}
        {...restProps}
      />
    </MuiPickersUtilsProvider>
  );
};

export default CustomDatePicker;
